module.exports = __webpack_public_path__ + "img/processing-security-visa.e30180bc.svg";